import {
  BlockUI,
  NgBlockUI
 }                          from 'ng-block-ui';
import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { NgForm }           from '@angular/forms';
import { UIRouter }         from '@uirouter/core';

import { CodeTypeModel }   from '../../app-lite/core/models/code-type';
import { MessagesService } from '../../app-lite/messages/messages.service';
import { UserService }     from './user.service';
import { UserSignUpModel } from './typings/user.sign-up';

@Component({
  selector   : 'wor-user-signup',
  template: require('./user.sign-up.component.html')
})
export class UserSignUpComponent {
  @BlockUI('userSignupBlock') block  : NgBlockUI;

  @Input() countries : Array<CodeTypeModel>;

  user : UserSignUpModel = {
    capricorn_id    : '',
    company_name    : '',
    confirm_password: '',
    country         : 'aus',
    email           : '',
    password        : '',
    unlock_code     : ''
  };

  constructor (
    private messagesService : MessagesService,
    private router          : UIRouter,
    private translateService: TranslateService,
    private userService     : UserService
  ) {}

  signUp ( form : NgForm ) : void {
    this.block.start();

    this.userService.signUp(this.user)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.CREATED.USER'), 'success');

      this.router.stateService.go('app.login');
    })
    .catch(( error ) => this.messagesService.error(error))
    .finally(() => this.block.stop());
  }
}
